module.exports = __webpack_public_path__ + "ea842d89f521d3afd5db9157a6577b46.svg";